import React from 'react';
import { LoadingIndicator } from '@spotify-internal/encore-web';
import { ContentGrid } from '../ContentGrid';
import { Box } from '../ui';
import { SearchResponse } from '.';

type SearchResultsComponentProps = {
  response: SearchResponse;
  getPageItems?: (page: number) => Promise<any[]>;
  hasNextPage?: (curPage: number) => boolean;
};

export const SearchResultsComponent: React.FC<SearchResultsComponentProps> = ({
  response,
  getPageItems = () => Promise.resolve([]),
  hasNextPage = () => false,
}) => {
  if (!response?.hits?.length) {
    return (
      <Box style={{ height: '100vh' }}>
        {response.query ? 'No results' : ''}
      </Box>
    );
  }

  return (
    <>
      {(response && (
        <ContentGrid
          trackCategory="Search"
          subtext={`${response.total} results`}
          items={response.hits}
          getPageItems={getPageItems}
          hasNextPage={hasNextPage}
          featuredItems={0}
        />
      )) || <LoadingIndicator />}
    </>
  );
};
